export enum AuthProcess {
  MFA_ENFORCE = 'enforce_mfa',
  MFA_PROCESS = 'mfa_process',
  PASSWORD_RENEW = 'PASSWORD_RENEW',
  AUTH_PASSWORD_RENEW = 'AUTH_PASSWORD_RENEW',
}
